import { useEffect, useRef } from "react";

/**
 *
 * @param method - the method will evoked every render until `true` is returned
 */
export function useUntil(method: () => boolean) {
  const stop = useRef<boolean>(false);

  useEffect(() => {
    if (stop.current === false) {
      stop.current = method();
    }
  });
}
